import React from 'react';
import { ABOUT_PAGE } from '../mock';
import Reveal from './Reveal';

const AboutHero = () => {
  const { hero } = ABOUT_PAGE;
  return (
    <section className="relative bg-cream pt-20">
      <div className="grid lg:grid-cols-2">
        {/* Text */}
        <div className="flex items-center px-6 py-12 md:px-14 md:py-20 xl:px-24">
          <div>
            <Reveal>
              <p className="mb-7 text-[10px] uppercase tracking-[0.5em] text-gold-dark">
                {hero.label}
              </p>
            </Reveal>
            <Reveal delay={120}>
              <h1 className="font-serif text-4xl font-light leading-[1.12] tracking-[0.02em] text-ink md:text-5xl xl:text-[3.4rem]">
                {hero.titleLines.map((line, i) => (
                  <React.Fragment key={line}>
                    {line}
                    {i < hero.titleLines.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </h1>
            </Reveal>
            <Reveal delay={240}>
              <div className="mt-7 h-px w-12 bg-gold" />
            </Reveal>
            <Reveal delay={320}>
              <p className="mt-7 text-[12px] font-medium tracking-[0.18em] text-ink">
                {hero.tagline}
              </p>
            </Reveal>
            <Reveal delay={400}>
              <p className="mt-4 max-w-md text-base leading-relaxed text-ink/65">
                {hero.text}
              </p>
            </Reveal>
          </div>
        </div>

        {/* Portrait — full image visible, panel filled with blurred backdrop */}
        <div className="relative min-h-[60vh] overflow-hidden bg-ink lg:min-h-[88vh]">
          <img
            src={hero.image}
            alt=""
            aria-hidden="true"
            loading="lazy"
            className="absolute inset-0 h-full w-full scale-110 object-cover opacity-70 blur-2xl"
          />
          <img
            src={hero.image}
            alt="Kanwal H. Malik portrait"
            className="absolute inset-0 h-full w-full object-contain object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-ink/40 via-transparent to-transparent" />
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
